import BaseChartOptions from '../../../utils/BaseChart/BaseChartOptions';

class StackedBarChartOptions extends BaseChartOptions {
    constructor(data: Array<any>, barIDs: string[]) {
        super(data);
        this.setChildren(
            barIDs.map((id) => ({
                id,
                type: 'interval',
                transform: [{ type: 'stackY' }],
            }))
        );
    }
}

export default StackedBarChartOptions;
